import { render, staticRenderFns } from "./surface-activity-svg.vue?vue&type=template&id=6b262c35&"
import script from "./surface-activity-svg.vue?vue&type=script&lang=ts&"
export * from "./surface-activity-svg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports